import {Observable, Subject} from 'rxjs'
import {PbmService} from '../pbm.service'
import {PbmFuncionalService} from './pbm-funcional.service'
import {CestaService} from '../../../cesta/cesta.service'
import {AdicionarCestaObserver} from '../../../cesta/adicionar/adicionarCesta.observer'
import {ModalPbmObserver} from '../modal-pbm.observer'
import {Message} from 'components/message'
import {ModalPbmComponent} from "../modal-pbm.component";

export class PbmFuncionalPreAuthComponent {

  constructor(data) {
    this.data = data;
    this.service = new PbmService();
    this.cestaService = new CestaService();
    this.funcionalService = new PbmFuncionalService();
    this.alert = new Message();
    this.modalPbm = new ModalPbmComponent();
  }

  getIdTransacao() {
    return this.service
      .getIdTransacao(this.data.dadosPbm.codigoAdminConvenio)
      .subscribe(this.idTransacaoResponse())
  }

  idTransacaoResponse() {
    return {
      next: idTransacao => this.preAutorizacao(idTransacao),
      error: error => {
        const msg = (error.status && error.status == 404) ? "Não foi possível autorizar este item" : error.data.mensagem
        this.alert.message = msg;
        this.alert.show();
      },
      complete: () => console.log('Complete'),
    }
  }

  preAutorizacao(idTransacao) {
    return this.service
      .preAutorizacao(this.funcionalService.buildRequest(idTransacao, this.data), this.data.dadosPbm.codigoAdminConvenio)
      .subscribe(this.preAutorizacaoResponse())
  }

  preAutorizacaoResponse() {
    return {
      next: preAutorizacao => {
        if (preAutorizacao.data.produtoCarrinhoRetornos.length > 0) {
          if (preAutorizacao.data.produtoCarrinhoRetornos[0].codigo.toUpperCase() == 'SUCESSO') {
            this.addToCart(preAutorizacao)
          } else {
            this.alert.message = preAutorizacao.data.produtoCarrinhoRetornos[0].codigo + " " + preAutorizacao.data.produtoCarrinhoRetornos[0].mensagem;
            this.alert.show();
            this.modalPbm.closeAll();
          }
        }
      },
      error: error => {
        const msg = (error.status && error.status == 404) ? "Não foi possível autorizar este item" : error.data.mensagem
        new Message(msg);
        this.modalPbm.closeAll();
      },
      complete: () => console.log('Complete'),
    }
  }

  addToCart(preAutorizacao) {
    return this.cestaService
      .adicionarItemNaCestaPbm(this.buildRequestAddToCart(preAutorizacao))
      .subscribe(this.addToCartResponse(preAutorizacao))
  }

  buildRequestAddToCart(preAutorizacao) {
    return {
      idProduto: this.data.dadosPbm.item,
      quantidade: this.data.dadosPbm.quantidadeSolicitada,
      pbm: true,
      pbmAdmin: this.data.dadosPbm.codigoAdminConvenio
    }
  }

  addToCartResponse(preAutorizacao) {
    let subjectCarrinho = new Subject();
    let subjectModalSuccess = new Subject();

    subjectCarrinho.subscribe(new AdicionarCestaObserver())
    subjectModalSuccess.subscribe(new ModalPbmObserver())

    return {
      next: response => {
        subjectCarrinho.next(response)
        subjectModalSuccess.next(this.buildModalSuccessData(preAutorizacao))
      },
      error: error => {
        const msg = (error.status && error.status == 404) ? "Não foi adicionar o item ao carrinho" : error.data.mensagem
        this.alert.message = msg;
        this.alert.show();
        this.modalPbm.closeAll();
      },
      complete: () => console.log('Complete'),
    }
  }

  buildModalSuccessData(preAutorizacao) {
    const item = this.buildItemFromPreAutorizacao(preAutorizacao)
    return {
      step: "success",
      valorAntigo: (item.valorUnitario * item.quantidade).toFixed(2),
      valorNovo: item.valorTotal.toFixed(2),
      valorDesconto: ((item.valorUnitario * item.quantidade) - item.valorTotal).toFixed(2),
      mensagem: (Number.parseInt(this.data.dadosPbm.quantidadeSolicitada) > item.quantidade) ? this.buildMensagemQuantidade(item, this.data) : this.buildMensagemQuantidadeIncrement(item)
    }
  }

  buildItemFromPreAutorizacao(preAutorizacao) {
    return preAutorizacao
      .data.produtoCarrinhoRetornos
      .filter(item => item.codigoItem == this.data.dadosPbm.item)[0]
  }

  buildMensagemQuantidade(item, dadosPbm) {
    return `Você solicitou ${dadosPbm.quantidadeSolicitada} unidades e foi autorizado ${item.quantidade} unidade(s).`
  }

  buildMensagemQuantidadeIncrement(item) {
    return `Você solicitou ${item.quantidade} unidade(s).`
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-funcional/pbm-funcional-pre-auth.component.js